/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  ExportProductQrCodeMutationRequest,
  ExportProductQrCodeMutationResponse,
} from "../types/ExportProductQrCode.ts"

export const exportProductQrCodeMutationKey = () =>
  [{ url: "/v1/product/export-product-qr-code" }] as const

export type ExportProductQrCodeMutationKey = ReturnType<
  typeof exportProductQrCodeMutationKey
>

/**
 * @summary Export product QR code
 * {@link /v1/product/export-product-qr-code}
 */
export async function exportProductQrCode(
  data: ExportProductQrCodeMutationRequest,
  config: Partial<RequestConfig<ExportProductQrCodeMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportProductQrCodeMutationResponse,
    ResponseErrorConfig<Error>,
    ExportProductQrCodeMutationRequest
  >({
    method: "POST",
    url: `/v1/product/export-product-qr-code`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function exportProductQrCodeMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<ExportProductQrCodeMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = exportProductQrCodeMutationKey()
  return mutationOptions<
    ResponseConfig<ExportProductQrCodeMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ExportProductQrCodeMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return exportProductQrCode(data, config)
    },
  })
}

/**
 * @summary Export product QR code
 * {@link /v1/product/export-product-qr-code}
 */
export function useExportProductQrCode<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<ExportProductQrCodeMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: ExportProductQrCodeMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<ExportProductQrCodeMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? exportProductQrCodeMutationKey()

  const baseOptions = exportProductQrCodeMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<ExportProductQrCodeMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ExportProductQrCodeMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<ExportProductQrCodeMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ExportProductQrCodeMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<ExportProductQrCodeMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ExportProductQrCodeMutationRequest },
    TContext
  >
}
